import { createSlice } from "@reduxjs/toolkit";
import { createNominee, getNominee, getProfile, updateNominee, updateProfile } from "./customer/customerActions";

const initialState = {
   success: null,
   loading: null,
   userLocation:{},
   customer: {
      aboutme: {
         present: { lat: 13.0827, lng: 80.2707 },
         permenent: { lat: 12.9716, lng: 77.5946 }
      },
      nominee: {
         present: { lat: 0, lng: 0 },
         permenent: { lat: 0, lng: 0 }
      }
   },
   error: null
};

const locationSlice = createSlice({
   name: "locations",
   initialState,
   reducers: {
      // customer reducers

      setUserlocation:(state,{payload})=>{
         state.userLocation = payload
      },
      aboutPresentLocation(state, action) {
         state.customer.aboutme.present = action.payload;
      },
      aboutPerementLocation(state, action) {
         state.customer.aboutme.permenent = action.payload;
      },
      nomineePresentLocation(state, action) {
         state.customer.nominee.present = action.payload;
      },
      nomineePerementLocation(state, action) {
         state.customer.nominee.permenent = action.payload;
      },

   },
   extraReducers: (builder) => {
      // get customer profile
      builder.addCase(getProfile.pending, (state) => {
         state.loading = true
      })
      builder.addCase(getProfile.fulfilled, (state, { payload }) => {
         state.loading = false
         state.customer.aboutme.present.lat = payload?.response?.data?.data?.item?.currentAddress?.location?.coordinates[1]
         state.customer.aboutme.present.lng = payload?.response?.data?.data?.item?.currentAddress?.location?.coordinates[0]
         state.customer.aboutme.permenent.lat = payload?.response?.data?.data?.item?.permanentAddress?.location?.coordinates[1]
         state.customer.aboutme.permenent.lng = payload?.response?.data?.data?.item?.permanentAddress?.location?.coordinates[0]
         // state.customer.nominee.present.lat = payload?.response?.data?.data?.item?.currentAddress?.location?.coordinates[0]
         // state.customer.nominee.present.lng = payload?.response?.data?.data?.item?.currentAddress?.location?.coordinates[1]
         // state.customer.nominee.permenent.lat = payload?.response?.data?.data?.item?.permanentAddress?.location?.coordinates[0]
         // state.customer.nominee.permenent.lng = payload?.response?.data?.data?.item?.permanentAddress?.location?.coordinates[1]
         state.success = payload?.response?.data?.success
      })
      builder.addCase(getProfile.rejected, (state, { payload }) => {

         state.loading = false
         state.error = true
      })

      // update customer profile
      builder.addCase(updateProfile.pending, (state) => {
         state.loading = true
      })
      builder.addCase(updateProfile.fulfilled, (state, { payload }) => {
         state.loading = false
         // state.customer.aboutme.present.lat = payload?.response?.data?.data?.item?.currentAddress?.location?.coordinates[0]
         // state.customer.aboutme.present.lng = payload?.response?.data?.data?.item?.currentAddress?.location?.coordinates[1]
         // state.customer.aboutme.permenent.lat = payload?.response?.data?.data?.item?.permanentAddress?.location?.coordinates[0]
         // state.customer.aboutme.permenent.lng = payload?.response?.data?.data?.item?.permanentAddress?.location?.coordinates[1]
         state.success = payload?.response?.data?.success
      })
      builder.addCase(updateProfile.rejected, (state, { payload }) => {

         state.loading = false
         state.error = true
      })

      //  get customer Nominee
      builder.addCase(getNominee.pending, (state) => {
         state.loading = true
      })
      builder.addCase(getNominee.fulfilled, (state, { payload }) => {
         state.loading = false
         if (payload?.response?.data?.data?.item?.currentAddress) {
            state.customer.nominee.present.lat = payload.response?.data?.data?.item?.currentAddress?.location?.coordinates[1]
            state.customer.nominee.present.lng = payload.response?.data?.data?.item?.currentAddress?.location?.coordinates[0]
         }
         if (payload?.response?.data?.data?.item?.permanentAddress) {
            state.customer.nominee.permenent.lat = payload?.response?.data?.data?.item?.permanentAddress?.location?.coordinates[1]
            state.customer.nominee.permenent.lng = payload?.response?.data?.data?.item?.permanentAddress?.location?.coordinates[0]
         }
         state.success = payload?.response?.data?.success
      })
      builder.addCase(getNominee.rejected, (state, { payload }) => {

         state.loading = false
         state.error = true
      })

      // Create customer Nominee
      builder.addCase(createNominee.pending, (state) => {
         state.loading = true
      })
      builder.addCase(createNominee.fulfilled, (state, { payload }) => {
         state.loading = false
         state.customer.nominee.present.lat = payload?.response?.data?.data?.item?.currentAddress?.location?.coordinates[1]
         state.customer.nominee.present.lng = payload?.response?.data?.data?.item?.currentAddress?.location?.coordinates[0]
         state.customer.nominee.permenent.lat = payload?.response?.data?.data?.item?.permanentAddress?.location?.coordinates[1]
         state.customer.nominee.permenent.lng = payload?.response?.data?.data?.item?.permanentAddress?.location?.coordinates[0]
         state.success = payload?.response?.data?.success
      })
      builder.addCase(createNominee.rejected, (state, { payload }) => {

         state.loading = false
         state.error = true
      })

      // update customer Nominee
      builder.addCase(updateNominee.pending, (state) => {
         state.loading = true
      })
      builder.addCase(updateNominee.fulfilled, (state, { payload }) => {
         state.loading = false
         state.customer.nominee.present.lat = payload?.response?.data?.data?.item?.currentAddress?.location?.coordinates[1]
         state.customer.nominee.present.lng = payload?.response?.data?.data?.item?.currentAddress?.location?.coordinates[0]
         state.customer.nominee.permenent.lat = payload?.response?.data?.data?.item?.permanentAddress?.location?.coordinates[1]
         state.customer.nominee.permenent.lng = payload?.response?.data?.data?.item?.permanentAddress?.location?.coordinates[0]
         state.success = payload?.response?.data?.success
      })
      builder.addCase(updateNominee.rejected, (state, { payload }) => {

         state.loading = false
         state.error = true
      })

   }
});

export const locationActions = locationSlice.actions;

export const {setUserlocation} = locationSlice.actions;

export default locationSlice.reducer
